import { render, staticRenderFns } from "./EditInputs.vue?vue&type=template&id=0c350718&scoped=true&"
import script from "./EditInputs.vue?vue&type=script&lang=js&"
export * from "./EditInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c350718",
  null
  
)

export default component.exports